<template>
  <div id="app">
    <MainComponent></MainComponent>
  </div>
</template>

<script>
import MainComponent from './components/MainComponent.vue'

export default {
  name: 'app',
  components: {
    MainComponent,
  },
};
</script>

<style></style>
